import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import showTeamTransactions from './teamTransactions';

/**
 * @param {String} prevOrNext Prev or next arrow
 * @return {String}
 */
function getArrow(prevOrNext) {
  if (prevOrNext === 'prev') {
    return `
        <span class="arrow-slick arrow-left slick-prev">
          <div class="arrow-switch">
            <svg xmlns="http://www.w3.org/2000/svg" class="arrow-switch-svg" viewBox="0 0 55 107">
              <path fill-rule="evenodd" fill="currentColor" d="M54.527 2.782L3.807 53.47l50.625 50.747c.63.632.63 1.66-.002 2.294-.632.635-1.657.635-2.288.003L.562 54.81c-.237-.24-.385-.534-.443-.84-.243-.59-.126-1.29.35-1.765L52.226.482c.633-.634 1.662-.632 2.298.003.636.635.637 1.664.003 2.297z"/>
            </svg>
          </div>
        </span>
      `;
  }
  return `
      <span class="arrow-slick arrow-right slick-next">
        <div class="arrow-switch">
          <svg xmlns="http://www.w3.org/2000/svg" class="arrow-switch-svg" viewBox="0 0 55 107">
            <path fill-rule="evenodd" fill="currentColor" d="M54.53 54.794L2.773 106.517c-.633.634-1.662.632-2.298-.003-.636-.636-.637-1.665-.004-2.297l50.72-50.69L.568 2.783C-.064 2.15-.062 1.122.57.488c.632-.633 1.657-.635 2.288-.002l51.58 51.704c.237.238.385.533.443.84.243.588.126 1.288-.35 1.764z"/>
          </svg>
        </div>
      </span>
    `;
}

/**
 *
 */
export default function startTabs() {
  $('.tabs-main-container .tabs-container').not('.slick-initialized').slick({
    arrows: true,
    asNavFor: '.tabs-main-container .tabs-content',
    dots: false,
    focusOnSelect: true,
    infinite: false,
    slidesToShow: document.querySelectorAll('.tabs-main-container .tabs-container .single-tab').length,
    prevArrow: getArrow('prev'),
    nextArrow: getArrow('next'),
    centerPadding: '0',
    responsive: [
      {
        breakpoint: 1000,
        settings: {
          centerPadding: '40px',
          slidesToShow: 3,
        },
      },
    ],
  });

  const $tabsContent = $('.tabs-main-container .tabs-content');

  $tabsContent.not('.slick-initialized').slick({
    adaptiveHeight: true,
    speed: 100,
    swipe: false,
    infinite: false,
    accessibility: false,
    arrows: false,
    dots: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $tabsContent.on('beforeChange', (event, slick, currentSlide, nextSlideIndex) => { // eslint-disable-line
    $('.choose-team-list').removeClass('active');
  });
}

/**
 * @param {Object} event Event object
 */
export async function openTeamsMenu(event) {
  event.preventDefault();
  const $chooseTeamList = $(this).siblings('.choose-team-list');

  $chooseTeamList.find('.loading-outer-container').removeClass('is-visible');

  if ($chooseTeamList.hasClass('active')) {
    $(this).siblings('.choose-team-list').removeClass('active');
  } else {
    $(this).siblings('.choose-team-list').addClass('active');
  }
}

/**
 * @param {Object} event Event object
 */
export function chooseTeamInMenu(event) {
  event.preventDefault();
  $('.choose-team-list').removeClass('active');
  $('.single-tab-teams').click();
  showTeamTransactions($(this));
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/components/main-tabs.js